"use strict";
/**
 * 打关数据格式化类 ver: 0
 * 无变化
 */
class ReplayDataFormatter_v0 {
    constructor() { }
    format(org) {
        return org;
    }
    unformat(formatted) {
        return formatted;
    }
}
module.exports = ReplayDataFormatter_v0;
/*
 格式化数据；
 {
        "1": {
            "isOver": true,
            "level": 801,
            "randomSeed": 531,
            "lvmd5": "abcde"
            "replaySteps": {
                "1": {
                    "x1": 7,
                    "x2": 6,
                    "y1": 5,
                    "y2": 5
                },
                "2": {
                    "x1": 9,
                    "x2": 8,
                    "y1": 5,
                    "y2": 5
                },
                "3": {
                    "x1": 7,
                    "x2": 8,
                    "y1": 3,
                    "y2": 3
                },
                "4": {
                    "x1": 8,
                    "x2": 8,
                    "y1": 4,
                    "y2": 5
                },
                "5": {
                    "attachData": null,
                    "prop": 10002,
                    "x1": 6,
                    "x2": 7,
                    "y1": 4,
                    "y2": 5
                },
                "6": {
                    "attachData": null,
                    "prop": 10006,
                    "x1": 7,
                    "x2": 0,
                    "y1": 4,
                    "y2": 0
                },
                "7": {
                    "attachData": null,
                    "prop": 10003,
                    "x1": 5,
                    "x2": 5,
                    "y1": 6,
                    "y2": 5
                },
                "8": {
                    "attachData": null,
                    "prop": 10005,
                    "x1": 5,
                    "x2": 0,
                    "y1": 5,
                    "y2": 1
                },
                "9": {
                    "x1": 6,
                    "x2": 5,
                    "y1": 6,
                    "y2": 6
                },
                "10": {
                    "x1": 5,
                    "x2": 6,
                    "y1": 4,
                    "y2": 4
                },
                "11": {
                    "x1": 9,
                    "x2": 9,
                    "y1": 5,
                    "y2": 6
                },
                "12": {
                    "x1": 7,
                    "x2": 6,
                    "y1": 4,
                    "y2": 4
                },
                "13": {
                    "x1": 8,
                    "x2": 9,
                    "y1": 2,
                    "y2": 2
                },
                "14": {
                    "x1": 6,
                    "x2": 6,
                    "y1": 4,
                    "y2": 5
                },
                "15": {
                    "x1": 5,
                    "x2": 5,
                    "y1": 5,
                    "y2": 6
                },
                "16": {
                    "x1": 6,
                    "x2": 5,
                    "y1": 5,
                    "y2": 5
                },
                "17": {
                    "x1": 5,
                    "x2": 4,
                    "y1": 4,
                    "y2": 4
                },
                "18": {
                    "x1": 4,
                    "x2": 5,
                    "y1": 6,
                    "y2": 6
                },
                "19": {
                    "x1": 7,
                    "x2": 7,
                    "y1": 4,
                    "y2": 5
                },
                "20": {
                    "x1": 7,
                    "x2": 7,
                    "y1": 5,
                    "y2": 6
                },
                "21": {
                    "x1": 8,
                    "x2": 7,
                    "y1": 6,
                    "y2": 6
                },
                "22": {
                    "x1": 7,
                    "x2": 7,
                    "y1": 4,
                    "y2": 5
                },
                "23": {
                    "x1": 9,
                    "x2": 9,
                    "y1": 4,
                    "y2": 3
                },
                "24": {
                    "x1": 6,
                    "x2": 5,
                    "y1": 4,
                    "y2": 4
                },
                "25": {
                    "x1": 4,
                    "x2": 4,
                    "y1": 6,
                    "y2": 7
                },
                "26": {
                    "x1": 6,
                    "x2": 6,
                    "y1": 7,
                    "y2": 8
                },
                "27": {
                    "x1": 6,
                    "x2": 7,
                    "y1": 8,
                    "y2": 8
                },
                "28": {
                    "x1": 6,
                    "x2": 5,
                    "y1": 6,
                    "y2": 6
                },
                "29": {
                    "x1": 5,
                    "x2": 5,
                    "y1": 6,
                    "y2": 7
                },
                "30": {
                    "x1": 4,
                    "x2": 5,
                    "y1": 7,
                    "y2": 7
                },
                "31": {
                    "x1": 7,
                    "x2": 6,
                    "y1": 7,
                    "y2": 7
                },
                "32": {
                    "x1": 9,
                    "x2": 9,
                    "y1": 7,
                    "y2": 8
                },
                "33": {
                    "x1": 8,
                    "x2": 7,
                    "y1": 8,
                    "y2": 8
                },
                "34": {
                    "x1": 4,
                    "x2": 5,
                    "y1": 7,
                    "y2": 7
                },
                "35": {
                    "x1": 7,
                    "x2": 6,
                    "y1": 8,
                    "y2": 8
                },
                "36": {
                    "finalAddStep": true,
                    "prop": 10004
                },
                "37": {
                    "x1": 5,
                    "x2": 6,
                    "y1": 3,
                    "y2": 3
                },
                "38": {
                    "x1": 5,
                    "x2": 4,
                    "y1": 8,
                    "y2": 8
                },
                "39": {
                    "x1": 5,
                    "x2": 5,
                    "y1": 7,
                    "y2": 8
                }
            },
            "reviveRef": {
                "10004": [
                    1002,
                    1003,
                    1004,
                    1005
                ]
            },
            "selectedItemsData": {}
        }
    }
 */ 
